export enum DispositionType {
  NetBetting,
  TheBlend,
  Fusion
}